import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { setFilmstripVisible } from '../filmstrip/actions.any';
import { setToolboxVisible } from '../toolbox/actions.any';
import { MOBILE_SCREENSHARE_FOCUS_BODY_CLASS } from './constants';
import { isMobileScreenshareFocusMode } from './functions.web';
import logger from './logger';
import { disableMobileScreenshareLandscape } from './orientation.web';
/**
 * 进入聚焦布局前记录的人员侧栏可见性，退出时用于还原。
 */
let filmstripVisibleBeforeFocus;
/**
 * 手机共享聚焦模式：自动收起人员侧栏，退出时还原。
 */
StateListenerRegistry.register(
/* selector */ state => isMobileScreenshareFocusMode(state), 
/* listener */ async (focusMode, store) => {
    const { dispatch, getState } = store;
    const { visible } = getState()['features/filmstrip'];
    if (focusMode) {
        document.body.classList.add(MOBILE_SCREENSHARE_FOCUS_BODY_CLASS);
        if (filmstripVisibleBeforeFocus === undefined) {
            filmstripVisibleBeforeFocus = visible;
            logger.info(`[手机共享布局] 进入聚焦模式，记录侧栏可见性 visible=${visible}`);
        }
        // alwaysVisible 场景下 redux.visible 可能一直是 false；进入聚焦后需显式置 true，
        // 否则 isToolboxVisible 不再吃 alwaysVisible 时上下栏会一进来就隐藏。
        dispatch(setToolboxVisible(true));
        logger.info('[手机共享布局] 进入聚焦模式，已确保工具栏可见');
        if (visible) {
            dispatch(setFilmstripVisible(false));
            logger.info('[手机共享布局] 已隐藏人员侧栏');
        }
        return;
    }
    document.body.classList.remove(MOBILE_SCREENSHARE_FOCUS_BODY_CLASS);
    try {
        await disableMobileScreenshareLandscape();
    }
    catch (error) {
        logger.warn('[手机共享布局] 退出聚焦时清理横屏状态失败', error);
    }
    // 退出共享聚焦后恢复上下栏，避免普通会议栏仍被隐藏。
    dispatch(setToolboxVisible(true));
    logger.info('[手机共享布局] 退出聚焦模式，已恢复工具栏可见');
    if (filmstripVisibleBeforeFocus !== undefined) {
        logger.info(`[手机共享布局] 退出聚焦模式，还原侧栏可见性 visible=${filmstripVisibleBeforeFocus}`);
        dispatch(setFilmstripVisible(filmstripVisibleBeforeFocus));
        filmstripVisibleBeforeFocus = undefined;
    }
});
